<template>
  <card class="no-border-card card-instructions">
    <template slot="header">
      <h3>Instructions</h3>
    </template>
      <h4>{{ recipeData.name }}</h4>
      <ul class="list-steps">
        <li v-for="(instruction, index) in instructions" :key="instruction.id">
          <span class="steps">{{ ++index }}</span>

          <div v-html="instruction.instruction "></div>
        </li>
      </ul>
  </card>
</template>
<script>

  export default {
    title: "recipe-instructions",
    props: ['recipeData'],
    data() {
      return {
      }
    },
    computed: {
      instructions() {
        if(this.recipeData.instructions){
          return this.recipeData.instructions.slice().sort((a,b) => {
            return a.sortOrder - b.sortOrder
          })
        }
        return [];
      }
    },
    methods: {
      onCreated() {
      }
    },
    created(){
      this.onCreated();
    },
    mounted() {
    },
    watch: {
      $route(to, from) {
        this.onCreated();
      }
    }
  }
</script>
<style></style>
